import React, {FC} from 'react';
import {IWifiAnalyzerResults} from '../../services/AngularServices/WifiAnalyzerService';
import {getWifiAnalyzerScanRecordId} from '../right-bar/wifi-scan-history.utils';
import './styles.scss';
import WifiFindOutlined from '../../../../img/wifi/WifiFindOutlined.png';
import {observer} from 'mobx-react';

interface IWifiScanHistoryButton {
    onClickWifiScanHistoryButton: (wifiScanId: string) => void;
    wifiScanData: IWifiAnalyzerResults;
    wifiScanTranslation: string;
}

function formatCreatedOn(dateInput: string | Date): string {
    const date = new Date(dateInput);

    const options: Intl.DateTimeFormatOptions = {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
    };

    const formatted = date.toLocaleString('en-US', options);

    return formatted.replace(',', '');
}

export const WifiScanHistoryButton: FC<IWifiScanHistoryButton> = observer(
    ({wifiScanData, onClickWifiScanHistoryButton, wifiScanTranslation}) => {
        const createdOnFormatted = formatCreatedOn(wifiScanData.createdOn);

        return (
            wifiScanData && (
                <div className='centered-column'>
                    <div className='scan-wifi-history-date'>{createdOnFormatted}</div>
                    <button
                        className='scan-wifi-history-btn-container'
                        onClick={() =>
                            onClickWifiScanHistoryButton(
                                getWifiAnalyzerScanRecordId(wifiScanData) ||
                                    String(wifiScanData._id ?? wifiScanData.id ?? '')
                            )
                        }
                        type='button'>
                        <img src={WifiFindOutlined} alt='WiFi scan icon' />
                        <span className='scan-wifi-history-btn-text'>{wifiScanTranslation}</span>
                    </button>
                </div>
            )
        );
    }
);
